import React, { useEffect } from 'react'
import TabComponent from '../../component/TabComponent'
import CampaignPlan from './campaignPlan'
import Delivery from './delivery'
import DistributionPlan from './distributionPlan'
import ProductionPlan from './productionPlan'
import PromoteSpread from './promoteSpread'
import { PlanProvider } from './services/planApi'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

export default function Plan() {
  const { profile } = useSelector(state => state.profile)
  const location = useLocation()
  const navigate = useNavigate()
  const dataTabs = [
    {
      title: 'แผนการผลิต/ทบทวน',
      page: <ProductionPlan />,
      url: '/plan/production-plan',
      Permit: profile?.Permissions?.find((x) => x?.Action === 'ProductionPlan.Read')?.Permit
    },
    {
      title: 'แผนการจำหน่าย',
      page: <DistributionPlan />,
      url: '/plan/distribution-plan',
      Permit: true
    },
    {
      title: 'แผนการส่งเสริมการกระจายเมล็ดพันธุ์ข้าว',
      page: <PromoteSpread />,
      url: '/plan/promote-spread',
      Permit: true
    },
    {
      title: 'สรุปการจัดส่งเมล็ดพันธุ์',
      page: <Delivery />,
      url: '/plan/delivery',
      Permit: true

    },
    {
      title: 'ใบตรวจการปฏิบัติงาน',
      page: <CampaignPlan />,
      url: '/plan/campaign-plan',
      Permit: true

    },

  ]

  useEffect(() => {
    if (location.pathname === '/plan') {
        navigate(dataTabs[0].url)
    }
}, [location.pathname])
  return (
    <div style={{ padding: '10px 30px' }}>
      <PlanProvider>
        <TabComponent dataTabs={dataTabs} />
      </PlanProvider>
    </div>
  )
}
